<template>
	<div class="card">
		<div class="card-body">
			<validation-observer v-slot="{ passes, invalid }">
				<form @submit.prevent="passes(save)">
					<div class="row align-items-center">
						<div class="col-5">
							<h5 :class="serialSelected ? 'text-primary' : 'text-muted'">
								<fa-icon
									:icon="['fas','qrcode']"
									class="mr-2"
								/>
								<!-- {{ fields.FacturaSerie || 'XXX' }} -->

								<g-inline-editor v-model="fields.FacturaSerie" />

								<a-tooltip placement="right">
									<template slot="title">
										<fa-icon
											icon="sync-alt"
											:spin="loadingSerial"
										/> {{ loadingSerial ? 'Refrescando...' : 'Refrescar nº de serie' }}
									</template>
									<sup
										v-if="serialSelected"
										class="ml-2 font-size-14 cursor"
										:class="loadingSerial ? 'text-muted' : 'text-primary'"
										@click="serialChange(serialSelected)"
									>
										<fa-icon
											icon="sync-alt"
											:spin="loadingSerial"
										/>
									</sup>
								</a-tooltip>
							</h5>
							<a
								class="cursor text-primary font-weight-bold"
								@click="vencimientosOpened = true"
							>

								<a-badge
									:count="fields.Vencimientos.length"
									:number-style="{
										backgroundColor: vencimientosStatus ? $colors.primary : $colors.danger
									}"
									:class="vencimientosStatus ?
										'text-primary' :
										'text-danger animate__animated animate__headShake animate__infinite'"
									:overflow-count="99"
									:offset="[15,0]"
								>
									Vencimientos
								</a-badge>
							</a>
						</div>

						<div class="col-7 d-flex">
							<div class="ml-auto d-flex align-items-center">
								<span class="mr-3 d-none d-sm-block">Fecha de factura:</span> <g-field
									v-model="fields.FacturaFecha"
									:app="app"
									name="FacturaFecha"
									placeholder="Fecha"
									:clean="true"
									class="mb-0"
								/>
							</div>
						</div>
					</div>

					<hr class="mb-4 mt-3">

					<div class="row align-items-stretch">
						<div class="col-2 d-none d-sm-flex align-items-center invoiceLogo">
							<img
								v-if="config.EmpresaLogo"
								:src="config.EmpresaLogo"
								class="w-100"
							>
							<img
								v-else
								class="w-100"
								src="https://calltek.es/assets/images/logo-dark.png"
							>
						</div>

						<div class="col-4 d-none d-sm-block">
							<div
								v-if="configLoaded"
								class="flex flex-1 flex-col"
							>
								<h5>Emisor</h5>

								<div class="invoice__recipient-info my-4">
									<span :class="{ 'text-danger': !config.EmpresaNombreComercial }">
										{{
											config.EmpresaNombreComercial ?
												config.EmpresaNombreComercial
												: 'Jhon Doe'
										}},
										{{ config.EmpresaCIF ? config.EmpresaCIF : '123456789W' }}
									</span>
									<br>
									<span :class="{ 'text-danger': !config.EmpresaDireccion }">
										{{ config.EmpresaDireccion ? config.EmpresaDireccion : '51 Edgemont Drive' }}
									</span>
								</div>
								<div class="invoice__recipient-contact ">
									<p>
										<fa-icon
											:icon="['fas', 'envelope']"
											:class="{ 'text-danger': !config.EmpresaEmail }"
										/>
										<span
											class="ml-2"
											:class="{ 'text-danger': !config.EmpresaEmail }"
										>{{ config.EmpresaEmail ? config.EmpresaEmail : 'jhon@doe.com' }}</span>
									</p>
									<p>
										<fa-icon
											:icon="['fas', 'phone']"
											:class="{ 'text-danger': !config.EmpresaTelefono }"
										/>
										<span
											class="ml-2"
											:class="{ 'text-danger': !config.EmpresaTelefono }"
										>{{ config.EmpresaTelefono ? config.EmpresaTelefono : '+54 123 123514' }}</span>
									</p>
								</div>
							</div>
						</div>

						<div class="col col-sm-6 mt-sm-0 mt-4 invoiceForm">
							<fieldset class="dashed m-t-20">
								<label><i class="zmdi zmdi-account-circle" /> Información General</label>

								<div class="clientStatus">
									<a-tag v-if="!clientSelected">
										Sin registrar
									</a-tag>
									<a-tag
										v-else
										color="green"
									>
										{{ fields.EmpresaNombre }} <fa-icon
											class="ml-1"
											:icon="['fas', 'times']"
											@click="clientReset"
										/>
									</a-tag>
								</div>

								<div class="row mb-3">
									<div class="col">
										<g-field
											v-model="fields.EmpresaNombre"
											:app="app"
											name="Empresa"
											placeholder="Razón Social"
											label="EmpresaNombre"
											:clean="true"
											:strict="false"
											@input="clientChange"
										/>
									</div>
									<div class="col">
										<g-field
											v-model="fields.EmpresaCIF"
											:app="app"
											name="EmpresaCIF"
											placeholder="CIF/NIF"
											label="EmpresaCIF"
											:clean="true"
											:strict="false"
											type="relation"
											table="empresas"

											ret-label="EmpresaNombre"
											@input="clientChange"
										/>
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-8">
										<g-field
											v-model="fields.EmpresaDomicilioSocial"
											:app="app"
											name="EmpresaDomicilioSocial"
											placeholder="Dirección"
											:clean="true"
										/>
									</div>

									<div class="col-4">
										<g-field
											v-model="fields.EmpresaCP"
											:app="app"
											name="EmpresaCP"
											placeholder="Código Postal"
											:clean="true"
										/>
									</div>
								</div>

								<div class="row">
									<div class="col">
										<g-field
											v-model="fields.EmpresaLocalidad"
											:app="app"
											name="EmpresaLocalidad"
											placeholder="Población"
											:clean="true"
										/>
									</div>
									<div class="col">
										<g-field
											v-model="fields.EmpresaProvincia"
											:app="app"
											name="EmpresaProvincia"
											placeholder="Provincia"
											:clean="true"
										/>
									</div>
									<div class="col">
										<g-field
											v-model="fields.EmpresaPais"
											:app="app"
											name="EmpresaPais"
											placeholder="Pais"
											:clean="true"
										/>
									</div>
								</div>
							</fieldset>
						</div>
					</div>

					<div class="mt-5 mb-2 row">
						<div class="col text-right">
							<a-button
								icon="plus"
								type="primary"
								@click="createConcept"
							>
								Añadir concepto
							</a-button>
						</div>
					</div>

					<table class="conceptsTable table table-responsive d-sm-table  table-hover table-striped">
						<thead>
							<th>PRODUCTO</th>
							<th>CONCEPTO</th>
							<th width="80px">
								CANTIDAD
							</th>
							<th width="80px">
								PRECIO
							</th>
							<th width="80px">
								DESCUENTO
							</th>
							<th
								width="120px"
								class="text-right"
							>
								TOTAL
							</th>
							<th width="50px" />
						</thead>

						<tbody>
							<tr
								v-for="(tr, i) in fields.Conceptos"
								:key="i"
								class="pb-3"
							>
								<td :style="{ 'min-width': '190px' }">
									<g-field
										v-model="tr.Producto"
										app="facturas_conceptos"
										name="Producto"
										placeholder="Producto"
										:clean="true"
										@input="productChange($event, i)"
									/>
								</td>
								<td :style="{ 'min-width': '190px' }">
									<g-field
										v-model="tr.Concepto"
										app="facturas_conceptos"
										name="Concepto"
										placeholder="Concepto"
										:clean="true"
									/>
								</td>
								<td :style="{ 'min-width': '160px' }">
									<g-field
										v-model="tr.Cantidad"
										app="facturas_conceptos"
										name="Cantidad"
										placeholder="Cantidad"
										:clean="true"
									/>
								</td>
								<td :style="{ 'min-width': '130px' }">
									<g-field
										v-model="tr.Precio"
										app="facturas_conceptos"
										name="Precio"
										placeholder="Precio"
										:clean="true"
									/>
								</td>
								<td :style="{ 'min-width': '100px' }">
									<g-field
										v-model="tr.Descuento"
										app="facturas_conceptos"
										name="Descuento"
										placeholder="Descuento"
										:clean="true"
									/>
								</td>
								<td
									class="text-right align-middle"
									:style="{ 'min-width': '100px' }"
								>
									{{ conceptTotal[i] }} €
								</td>
								<td
									class="text-center align-middle"
									:style="{ 'min-width': '50px' }"
								>
									<a
										v-show="i > 0"
										@click="removeConcept(i)"
									>
										<fa-icon :icon="['fas', 'times']" />
									</a>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="row">
						<div class="col-12 col-sm-6">
							<g-field
								v-model="fields.FacturaObservaciones"
								type="textarea"
								:app="app"
								name="FacturaObservaciones"
								placeholder="Observaciones"
								:clean="true"
							/>
						</div>

						<div class="col-12 col-sm-4 mt-4 mt-sm-0 offset-sm-2 align-self-end">
							<div class="row">
								<div class="col-12">
									<table class="table table-bordered mb-3">
										<tbody>
											<tr>
												<th class="text-right">
													SUBTOTAL
												</th>
												<td class="text-right">
													{{ subtotal | price }} €
												</td>
											</tr>
											<tr v-show="taxes.iva > 0">
												<th class="text-right">
													IVA <sup>{{ taxes.iva }}%</sup>
												</th>
												<td class="text-right">
													{{ iva | price }} €
												</td>
											</tr>
											<tr v-show="taxes.irpf > 0">
												<th class="text-right">
													IRPF <sup>{{ taxes.irpf }}%</sup>
												</th>
												<td class="text-right">
													{{ iva | price }} €
												</td>
											</tr>
											<tr>
												<th class="text-right">
													TOTAL
												</th>
												<td class="text-right">
													{{ total | price }} €
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div class="row mt-3">
						<div class="col-6 d-flex align-items-center">
							<b class="mr-3 d-none d-sm-block text-dark">Serie:</b>

							<g-field
								v-model="fields.Serie"
								:app="app"
								name="Serie"
								placeholder="Nº de serie"
								ret-label="SerieNombre"
								:clean="true"
								style="min-width: 120px"
								@input="serialChange"
							/>
						</div>
						<div class="col-6 text-right">
							<a-button-group>
								<a-popconfirm
									title="¿Estas seguro que deseas resetear el formulario?"
									@confirm="() => reset()"
								>
									<a-button type="danger">
										<fa-icon
											:icon="['fas','brush']"
											class="mr-2"
										/> Resetear
									</a-button>
								</a-popconfirm>
								<a-button
									type="primary"
									html-type="submit"
									:loading="loading"
									:disabled="invalid || !vencimientosStatus"
								>
									<template v-if="id > 0">
										<fa-icon
											:icon="['fas','edit']"
											class="mr-2"
										/>
										Modificar
									</template>

									<template v-else>
										<fa-icon
											:icon="['fas','plus-square']"
											class="mr-2"
										/>

										Añadir
									</template>
								</a-button>
							</a-button-group>
						</div>
					</div>
				</form>
			</validation-observer>
		</div>
		<vencimientos
			v-model="fields.Vencimientos"
			:total="total"
			:visible="vencimientosOpened"
			@close="vencimientosOpened = false"
			@ok="vencimientosStatus = true"
			@ko="vencimientosStatus = false"
		/>
	</div>
</template>

<script>
import _ from 'lodash';
import concepts from './_concepts';
import selects from './_selects';
import calculations from './_calculations';
import vencimientos from './vencimientos';
import seriesMX from '../../../helpers/series';
import facturasMX from '../../../helpers/facturas';

export default {
	components: { vencimientos },
	mixins: [concepts, selects, calculations],
	data() {
		return {
			id: this.$route.params.id || 0,
			view: 'facturaForm',
			app: 'facturas',
			loading: false,
			config: {
				EmpresaNombre: '',
				EmpresaNombreComercial: '',
				EmpresaCIF: '',
				EmpresaEmail: '',
				EmpresaDireccion: '',
				EmpresaWeb: '',
				EmpresaHorario: '',
				EmpresaTelefono: '',
				EmpresaLogo: '',
				EmpresaIcono: ''
			},
			loaded: false,
			configLoaded: false,
			vencimientosOpened: false,
			vencimientosStatus: true,
			fields: {
				Serie: null,
				Empresa: null,
				EmpresaNombre: '',
				EmpresaDomicilioSocial: '',
				EmpresaCP: '',
				EmpresaLocalidad: '',
				EmpresaProvincia: '',
				EmpresaPais: '',
				EmpresaCIF: '',
				FacturaSerie: '',
				FacturaFecha: this.$moment().format('YYYY-MM-DD'),
				FacturaObservaciones: '',
				FacturaEstado: 0,
				Conceptos: [
					{
						Cantidad: 1,
						Concepto: '',
						Producto: null,
						Precio: 0,
						Descuento: 0
					}
				],
				Vencimientos: [{
					VencimientoFecha: this.$moment().format('YYYY-MM-DD'),
					VencimientoImporte: 0
				}]
			},
			taxes: {
				iva: 0,
				irpf: 0
			}
		};
	},
	computed: {
		clientSelected() {
			if (this.fields.Empresa) return true;
			return false;
		},
		serialSelected() {
			return this.$vault.get('storedSerial');
		}
	},
	watch: {
		total(val) {
			if (this.fields.Vencimientos.length <= 1) {
				this.fields.Vencimientos[0].VencimientoImporte = val;
			}
		}
	},
	async created() {
		const config = await this.$gestios.config.list(Object.keys(this.config));

		if (config.ok) {
			this.configLoaded = true;
			Object.keys(this.config).forEach((key) => {
				this.config[key] = config.data[key];
			});
		} else {
			this.$router.push({ name: '_500', query: { error: 'No se ha podido cargar la configuración del aplicativo' } });
		}

		this.id = this.$route.params.id || 0;

		if (this.id > 0) {
			const result = await this.$gestios.items('facturas').get(this.id);

			if (result.ok) {
				const invoice = result.data;

				this.fields.Serie = {
					key: invoice.Serie._EntityId.toString(),
					label: invoice.Serie.SerieNombre,
					data: invoice.Serie
				};

				this.fields.Empresa = invoice.Empresa;
				this.fields.EmpresaNombre = invoice.EmpresaNombre;
				this.fields.EmpresaDomicilioSocial = invoice.EmpresaDomicilioSocial;
				this.fields.EmpresaCP = invoice.EmpresaCP;
				this.fields.EmpresaLocalidad = invoice.EmpresaLocalidad;
				this.fields.EmpresaProvincia = invoice.EmpresaProvincia;
				this.fields.EmpresaPais = invoice.EmpresaPais;
				this.fields.EmpresaCIF = invoice.EmpresaCIF;
				this.fields.FacturaSerie = invoice.FacturaSerie;
				this.fields.FacturaFecha = invoice.FacturaFecha;
				this.fields.FacturaObservaciones = invoice.FacturaObservaciones;
				this.fields.FacturaEstado = invoice.FacturaEstado;
				this.fields.Conceptos = [];
				this.fields.Vencimientos = [];

				invoice.Conceptos.forEach((c) => {
					const params = {
						Cantidad: c.Cantidad,
						Concepto: c.Concepto,
						Producto: null,
						Precio: c.Precio,
						Descuento: c.Descuento
					};

					if (c.Producto) {
						params.Producto = {
							key: c.Producto.toString(),
							label: c.Concepto
						};
					}

					this.fields.Conceptos.push(params);
				});

				invoice.Vencimientos.forEach((v) => {
					const params = {
						VencimientoFecha: v.VencimientoFecha,
						VencimientoImporte: v.VencimientoImporte
					};

					this.fields.Vencimientos.push(params);
				});
			}
		} else {
			this.reset();
			const storedSerial = this.$vault.get('storedSerial');
			if (storedSerial) this.fields.Serie = storedSerial;
		}

		setTimeout(() => {
			this.loaded = true;
		}, 3000);
	},
	methods: {
		async save() {
			this.loading = true;

			const params = _.cloneDeep(this.fields);
			const serie = (params.Serie && params.Serie.data) ? params.Serie.data : null;

			params.Empresa = params.Empresa ? params.Empresa._EntityId : null;
			params.Serie = serie ? serie._EntityId : null;
			params.FacturaSubtotal = this.subtotal;
			params.FacturaTotal = this.total;
			params.FacturaIVA = this.iva;
			params.FacturaRetenciones = this.irpf;

			params.Conceptos = JSON.stringify(
				params.Conceptos.map((c) => ({
					Cantidad: c.Cantidad,
					Concepto: c.Concepto,
					Producto: (c.Producto && c.Producto.key) ? c.Producto.key : null,
					Precio: c.Precio,
					Descuento: c.Descuento
				}))
			);

			params.Vencimientos = JSON.stringify(
				params.Vencimientos.map((v) => ({
					VencimientoFecha: v.VencimientoFecha,
					VencimientoImporte: v.VencimientoImporte
				}))
			);

			let data;
			if (this.id > 0) {
				data = await this.$gestios.items('facturas').edit({ id: this.id, params });
			} else {
				data = await this.$gestios.items('facturas').add({ params, view: this.view });
			}

			if (data.ok) {
				if (this.id === 0) await seriesMX.editSerialValue(serie);
				await facturasMX.renderPDF(data.data);
				this.$router.push({ name: 'facturas' });
			}

			this.loading = false;
		},
		reset() {
			this.loaded = false;

			this.clientReset();
			this.fields.Conceptos = [];
			this.fields.Vencimientos = [{
				VencimientoFecha: this.$moment().format('YYYY-MM-DD'),
				VencimientoImporte: 0
			}];
			this.createConcept();

			this.loaded = true;
		},
		clientReset() {
			this.fields.Empresa = null;

			this.fields.EmpresaNombre = '';
			this.fields.EmpresaDomicilioSocial = '';
			this.fields.EmpresaCP = '';
			this.fields.EmpresaLocalidad = '';
			this.fields.EmpresaProvincia = '';
			this.fields.EmpresaPais = '';
			this.fields.EmpresaCIF = '';
		}
	}
};
</script>

<style lang="scss">
@import '@/application/assets/scss/invoices.scss'
</style>
